/** Returns which API call to use for re-inviting based on invite type. */
export function resolveResendMethod(type: string | undefined): 'patch' | 'quote' {
  return type === 'quote' ? 'quote' : 'patch';
}
